export { default } from './SchoolList'
